/**
 * 署名キャンバスを ePOS-Print <image> 用の1bitモノクロラスタ(base64)に変換する。
 * PNG等をそのまま渡せないプリンタ仕様のため、縮小→白背景合成→輝度しきい値で2値化し、
 * 1行を8px/byte(MSBファースト、1=黒)でパックする。
 */
export default function canvasToMonoRaster(canvas, targetWidth = 360) {
  const scale = targetWidth / canvas.width
  const width = targetWidth
  const height = Math.max(1, Math.round(canvas.height * scale))

  const work = document.createElement('canvas')
  work.width = width
  work.height = height
  const ctx = work.getContext('2d')
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, width, height)
  ctx.drawImage(canvas, 0, 0, width, height)

  const { data } = ctx.getImageData(0, 0, width, height)
  const bytesPerRow = Math.ceil(width / 8)
  const raster = new Uint8Array(bytesPerRow * height)

  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      const i = (y * width + x) * 4
      const luminance = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
      if (data[i + 3] > 127 && luminance < 160) {
        // eslint-disable-next-line no-bitwise
        raster[y * bytesPerRow + (x >> 3)] |= 0x80 >> (x % 8)
      }
    }
  }

  let binary = ''
  for (let i = 0; i < raster.length; i += 1) binary += String.fromCharCode(raster[i])

  return { raster: window.btoa(binary), width, height }
}
